import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Chip, Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ReadOnlyTextField from 'src/components/widgets/readonly-textfield';
import QuillEditor from 'src/components/quill-editor';
import { getImg } from 'src/services/AssetApi';
import ZoomImage from 'src/components/zoom-image';

export const DetailView = ({ item, apiPayBill }) => {
  const imageSrc = useMemo(() => getImg(item.asset?.name), [item.asset?.name]);

  return (
    <Card>
      <CardContent sx={{ px: 1, py: 2 }}>
        <Grid container spacing={3} alignItems="flex-start">
          <Grid xs={12} md={6} container spacing={3}>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Biển số"  value={item.car?.name} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Tổng tiền" value={item.price} enumType="decimal" />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="ODO bảo dưỡng" value={item.atKm} enumType="decimal" />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Ngày bảo dưỡng"  value={item.atTime} dateFormat="dd/MM/yyyy" />
            </Grid>
            <Grid xs={12} md={12}>
              <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                {Array.isArray(item.services) && item.services.map((option) => (
                  <Chip
                    key={option.value}
                    label={option.label}
                    sx={{
                      m: 0.5,
                      p: 0.5,
                      '& .MuiChip-label': {
                        fontSize: '0.9rem'
                      }
                    }}
                  />
                ))}
              </Box>
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Liên hệ"  value={item.contact?.name} />
            </Grid>
            <Grid xs={12} md={6}>
              <ReadOnlyTextField label="Số điện thoại" value={item.contact?.phone} enumType="phone" />
            </Grid>
            <Grid xs={12} md={12}>
              <QuillEditor
                value={item.note}
                isReadOnly={true}
              />
            </Grid>
          </Grid>
          <Grid xs={12} md={6}>
            <ZoomImage
              thumbSrc={imageSrc}
              zoomSrc={imageSrc}
              height="390"
              frame="auto"
            />
          </Grid>
          {item.payment?.status === 0 && (
            <Grid xs={12} md={6} display="flex"
                  sx={{ justifyContent: { xs: 'center', md: 'flex-end' } }}>
              <Button variant="contained" onClick={() => {
                  const updatedPayment = {
                    ...item.payment,
                    status: 2,
                  };
                  apiPayBill(updatedPayment);
                }}>
                Thanh toán
              </Button>
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

DetailView.propTypes = {
  item: PropTypes.object.isRequired,
  apiPayment: PropTypes.func,
};